import split from "lodash/fp/split";
import first from "lodash/fp/first";
import last from "lodash/fp/last";
import isString from "lodash/fp/isString";
import mapsLoader from "google-maps";

class Controller {
  constructor($mdDialog, $injector, station, $q, NgMap, GoogleMaps) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.station = station;
    this.$q = $q;
    this.District = $injector.get("District");

    /*
      Actually we are loading google maps scripts twice due to a lack of code organization.
      There is large logic that uses ng-map to render and another is using google maps api.
      This update has been done because we want not to expose the google maps api key where it's not needed.
      We encapsulated all the logic into each component so google maps key is not exposed unless
      user is logged in and is opening a component that uses google maps.
    */

    // This one for ng-map
    this.googleMapsUrl = GoogleMaps.getSource();

    // And this one for google maps api used in the controller
    mapsLoader.KEY = process.env.GOOGLE_MAPS_API_KEY;
    mapsLoader.load((google) => {
      const geocoder = new google.maps.Geocoder();

      this.fetchGoogleMapsAddress = (lat, lng) => {
        const defer = this.$q.defer();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status !== "OK") return;
          defer.resolve(results[0].formatted_address);
        });
        return defer.promise;
      };
    });
  }

  $onInit() {
    this.station = {
      ...this.station,
      name: {
        value: this.station.name,
      },
      nameAr: {
        value: this.station.nameAr || "",
      },
      address: {
        value: this.station.address || "",
      },
      addressAr: {
        value: this.station.addressAr || "",
      },
      location: {
        value: this.station.location,
      },
      district: {
        value: this.station.district,
      },
    };

    this.getLatLng = (location) => {
      const transformLocation = isString(location)
        ? split(", ", location)
        : location;
      const lat = Number(first(transformLocation));
      const lng = Number(last(transformLocation));

      return { lat, lng };
    };

    const { lat, lng } = this.getLatLng(this.station.location.value);

    this.District.find({ lat, lng }).$promise.then(
      (response) => {
        this.station.district = {
          key: "district",
          value: response,
        };
        this.station.hasDistrict = true;
      },
      () => {
        this.station.hasDistrict = false;
      }
    );
  }

  getStationAddress() {
    const { lat, lng } = this.getLatLng(this.station.location.value);

    this.fetchGoogleMapsAddress(lat, lng).then((address) => {
      this.station.address.value = address;
    });
  }

  close() {
    this.$mdDialog.cancel();
  }

  save() {
    this.$mdDialog.hide(this.station);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/dialogs/stationInfoDialog/stationInfoDialog.controller.js